import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import styles from './textarea.css';
import { Textarea as Component } from './textarea';
import type { IDependencies, IProps } from './models';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const Textarea = createWidget<IDependencies, IProps>({
    styles,
    Text,
})(Component);
